import { helper } from '@ember/component/helper';
import { set } from '@ember/object';

// used exclusively for "revert on empty" functionality in inputs
// because by introducing Form::Input proxy for inbuilt Input helper
// we lost the ability to "mutate" given arguments (Input is two-way, Form::Input isn't)
// and migrating them all to proper methods on the parent components would take too long

const setField = function (_: unknown, hash: { target: object; property: string }) {
	const target = hash.target,
		property = hash.property;
	return (value: unknown) => {
		set(target, property, value);
	};
};

const setFieldHelper = helper(setField);

export default setFieldHelper;
